import React, { useState } from 'react';
import style from './style.module.scss';
import ButtonIcon from "../../../../../../../components/ButtonIcon/ButtonIcon";
import InfoIcon from "../../../../../../../assets/svg/icons/common/info";
import DepositDetailModal from "./detail-modal";
import { dateFormatter, formatCurrency } from ".././../../../../../../../components/helper/helper";

const Row = ({ data }) => {
  const [isDetailOpen, setIsDetailOpen] = useState(false);

  return (
    <>
      <tr className={style.table_row}>
        <td className={`${style.table_cell} ${style.padding_left}`}>{data?.routing_num ? data?.routing_num : '-'}</td>
        <td className={style.table_cell}>{data?.process_date ? dateFormatter(data?.process_date) : "-"}</td>
        <td className={style.table_cell}>{data?.account_num ? data?.account_num : '-'}</td>
        <td className={style.table_cell}>{data?.offset_description ? data?.offset_description : '-'}</td>
        <td className={style.table_cell}>{data?.transaction_code ? data?.transaction_code : '-'}</td>
        <td className={style.table_cell}>{data?.debit_credit ? data?.debit_credit : '-'}</td>
        <td className={style.table_cell}>{data?.deposit_date ? dateFormatter(data?.deposit_date) : "-"}</td>
        <td className={`${style.table_cell} ${data?.amount && data?.amount < 0 ? style.text_red : ''}`}>
          $ {data?.amount ? formatCurrency(data?.amount) : '-'}
        </td>
        <td className={style.table_cell}>
          <ButtonIcon
            bgColor="#EDEDF4"
            title="View deposit details"
            onClick={() => setIsDetailOpen(true)}
          >
            <InfoIcon />
            <span>Details</span>
          </ButtonIcon>
        </td>
      </tr>
      <DepositDetailModal
        isOpen={isDetailOpen}
        onClose={() => setIsDetailOpen(false)}
        data={data}
      />
    </>
  );
}

export default Row
